module.exports = __webpack_public_path__ + "img/boy-body-front.4cfed21c.png";